import request from '@/utils/request'

let StoreapplyApi = {

  /*门店入驻信息列表*/
  list(data) {
    return request._post('/shop/plus.storeapply.Index/index', data);
},
/*添加门店入驻信息*/
add(data) {
    return request._post('/shop/plus.storeapply.Index/add', data);
},
/*修改门店入驻信息*/
edit(data) {
    return request._post('/shop/plus.storeapply.Index/edit', data);
},
/*删除门店入驻信息*/
del(data) {
    return request._post('/shop/plus.storeapply.Index/del', data);
},
/*门店入驻信息详情*/
detail(data) {
  return request._post('/shop/plus.storeapply.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.storeapply.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.storeapply.Setting/getSetting', data, errorback);
    },
}
export default StoreapplyApi;



// WEBPACK FOOTER //
// ./src/api/storeapply.js